<template>
    <div>
        <div class="d-flex align-center mb-1">
            <v-tooltip bottom small>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon class="mr-2" :to="{name: 'orders'}" exact v-bind="attrs" v-on="on">
                        <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>
                </template>
                <span>{{ $t('views.main.orders.warehouse_app_order.back_to_list') }}</span>
            </v-tooltip>
        </div>

        <v-divider class="my-2"></v-divider>

        <v-row class="align-center my-1">
            <v-col cols="6">
                <div class="text-subtitle-1 font-weight-bold">
                    <span class="d-none d-sm-inline">{{ $t('views.main.orders.warehouse_app_order.order') }}</span>
                    {{ order.OrderName }}
                </div>
            </v-col>
            <v-col cols="6" class="text-right">
                <order-status-chip
                    :order-status="order.OrderStatus"
                    :order-status-name="order.OrderStatusName"
                ></order-status-chip>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" md="10" order="2" order-md="1">
                <v-alert type="info" v-if="order.OrderStatus === 3">
                    {{ $t('views.main.orders.warehouse_app_order.cant_edit_closed_orders') }}
                </v-alert>
                <v-alert type="info" v-else>
                    {{ $t('views.main.orders.warehouse_app_order.cant_edit_manufacturer_order') }}
                </v-alert>

                <components-table :units="order.Units"></components-table>
            </v-col>
            <v-col cols="12" md="2" order="1" order-md="2">
                <div class="text--secondary text-body-2">
                    <v-icon>
                        mdi-calendar-clock
                    </v-icon>
                    {{ $t('views.main.orders.warehouse_app_order.order_from_day') }}
                </div>
                <div class="text-body-1 mb-5">
                    {{ order.OrderDate | dateFormat }} <small>{{ order.OrderDate | timeFormat }}</small>
                </div>

                <template v-if="order.ClientOrderName">
                    <div class="text--secondary text-body-2">
                        <v-icon>
                            mdi-counter
                        </v-icon>
                        {{ $t('views.main.orders.warehouse_app_order.client_order_name') }}
                    </div>
                    <div class="text-body-1 mb-5">
                        {{ order.ClientOrderName }}
                    </div>
                </template>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import ComponentsTable from "../../../components/ComponentsTable";
import OrderStatusChip from "../../../components/OrderStatusChip";

export default {
    name: "WarehouseAppOrder",

    components: {
        ComponentsTable,
        OrderStatusChip,
    },

    props: {
        order: Object,
    },
}
</script>

<style scoped>

</style>
